import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-809ae11a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-backdrop" }, null, -1))
const _hoisted_2 = { class: "ReportPage" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = {
  class: "col-10 d-flex flex-column justify-content-center align-items-center",
  style: {"gap":"50px"}
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Ingreso Cuarto Frío", -1))
const _hoisted_7 = { class: "row mb-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Fecha", -1))
const _hoisted_9 = { class: "col-sm-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Llegada", -1))
const _hoisted_11 = { class: "col-sm-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Hora", -1))
const _hoisted_13 = { class: "col-md-2" }
const _hoisted_14 = { class: "row mb-1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Transac.", -1))
const _hoisted_16 = { class: "col-sm-3" }
const _hoisted_17 = { selected: "" }
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Docto.", -1))
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Guía", -1))
const _hoisted_22 = { class: "col-md-2" }
const _hoisted_23 = { class: "row mb-1" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Cliente", -1))
const _hoisted_25 = { class: "col-md-7" }
const _hoisted_26 = { selected: "" }
const _hoisted_27 = ["value"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Estado", -1))
const _hoisted_29 = { class: "col-md-3" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "I" }, "Ingreso", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "D" }, "Despachado", -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "row mb-1" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Comentario", -1))
const _hoisted_35 = { class: "col-md-9" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "div-dotted" }
const _hoisted_38 = { class: "col-md-1" }
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = { class: "col-md-2" }
const _hoisted_41 = ["onUpdate:modelValue"]
const _hoisted_42 = { class: "col-md-2" }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = { class: "col-md-2" }
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = { class: "col-md-2" }
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = { class: "col-md-2" }
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "A" }, "Activo", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "I" }, "Inactivo", -1))
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]

import { Ref,ref, computed, watch, onMounted } from 'vue'
import axios from 'axios';
import { useDateTimeStore } from '@/store/dateTimeStore';
import { userGlobalStore } from '@/store/userGlobal';
import { UrlGlobal } from '@/store/dominioGlobal';
import { useAlert } from '@/store/useAlert';
import LogTral from '../LogTral.vue';
 
type Registro = {
  secuencia: number | null
  orden_produccion: string | null
  pallets: string| null
  peso: string | null
  cajas: string | null
  status: string
}

// Inicializa con una sola fila vacía

export default /*#__PURE__*/_defineComponent({
  __name: 'InCuartoFrio',
  props: {
    btnIn: Boolean,
    fecha: String
     
},
  emits: ['insertProps'],
  setup(__props, { emit: __emit }) {

const { success, error, question, warning } = useAlert()

const dUrl = UrlGlobal()
const dateTimeStore = useDateTimeStore();
const userStore = userGlobalStore();



//variables reactivas para los campos del formulario
//const fecha = ref<string>('')
//const status = ref<string>('')
//const fecha_llegada = ref<string>('')
//const hora_llegada = ref<string>('')
//const codigo = ref<string>('')
//const guia = ref<string>('')
//const documento = ref<string>('')
//const cliente = ref<string>('')

let fila = 1
//props y emits----------------------------------------------------------------
const props = __props
const emits = __emit
        const handleClick = () =>{
            emits("insertProps",!props.btnIn)
            
        }
//----------------------------------------------------------------
// Valida Array
function valida(arr: string[]): boolean {
  let valido = true
  const uniqueElement = new Set(arr)
  if (arr.length != uniqueElement.size) {
    valido = false
  }

  return valido
}

let fecha = ref(props.fecha)
let docto: string

// envio del insert a la tabla en la base de datos a traves de la api en django
const handleSubmit = async () =>{
    dateTimeStore.refreshDateTime();
    
// VALIDACIONES
    if(!formDataI.value.fecha) {
        error('No tiene fecha la transacción... ')
        return
    }

    const fecha_i = new Date(formDataI.value.fecha)
    const fecha_f = new Date(formDataI.value.fecha_llegada)

    if(fecha_f > fecha_i) {
        error('Fecha de Llegada no puede ser mayor a la fecha... ')
        return
    }
    //if(!formDataI.value.documento) {
    //    error('Digite el documento de movimiento... ')
    //    return
    //}
    if(!formDataI.value.guia) {
        error('Digite la guía de movimiento... ')
        return
    }
   
    if(!formDataI.value.codigo) {
        console.log(formDataI.value.codigo)
        error('Escoja la transacción... ')
        return
    }
    if (!formDataI.value.cliente) {
        error('Digite el cliente propietario de la mercancía... ')
        return
    }
    if(!formDataI.value.comentario) {
        error('Digite los comentarios del ingreso... ')
        return
    }
// VALIDA ARRAY
     
    const guiaArray: (string | null)[]= registros.value.map(item => item.orden_produccion)
  
    const arrayFn = guiaArray.filter((item): item is string => item !=null)

    let resultado: boolean = valida(arrayFn);
    if (!resultado) {
        error('Existen números de pallets repetidos... ')
        return
    }
// VALIDA CONTENIDO DEL ARRAY
    let indice = registros.value.length -1
    for (let i = 0; i < indice; i++) {
        const arreglo = registros.value[i]
        let pallets = Number(arreglo.pallets)
        let peso = Number(arreglo.peso)
        let cajas = Number(arreglo.cajas)
        if (typeof arreglo.orden_produccion !== 'string' || arreglo.orden_produccion.trim() === '') {
            error (`Error: Falta el número de Pallet en la posición ${arreglo.secuencia}`)
            return
        }
        if (typeof pallets !== 'number' || pallets < 0) {
            error (`Error: Campo cantidad de Pallets es incorrecto en la secuencia ${arreglo.secuencia}`)
            return
        }
        if (typeof cajas !== 'number' || cajas < 0) {
            error (`Error: Campo cantidad de Cajas es incorrecto en la secuencia ${arreglo.secuencia}`)
            return
        }
        if (pallets == 0 && cajas == 0) {
            error (`Error: Pallets o Cajas deben tener valor en la secuencia ${arreglo.secuencia}`)
            return
        }
        if (typeof peso !== 'number' || peso <= 0 || peso == undefined) {
            error (`Error: Campo peso es incorrecto en la secuencia ${arreglo.secuencia}`)
            return
        }
    }

// VALIDA QUE GUÍA POR CLIENTE NO SE REPITA
    try {
        const response = await axios.post(dUrl.urlGlobal + '/api2/query', { tabla: 'logctmo', 
            filtro: { compania:'300', agencia: '001', fecha: formDataI.value.fecha, almacen: '02', 
                cliente: formDataI.value.cliente, guia_despacho: formDataI.value.guia }});

        dataList.value = response.data;

        if (dataList.value.length > 0) {
        warning('Al Cliente ya se le registro esta guía en el almacén', 'Valide la Información a Registrar')
        return
        }

    } catch (err: any) {
        error(err.response?.data?.detail || 'Ocurrió un error en la consulta.')
    }

    const result = await question(
    'Se va a insertar el campo con los nuevos datos.',
    '¿Deseas insertar este registro?'
    )

    if (!result.isConfirmed) {
        return
    }

    //registros.value.pop()
    registros.value.length = registros.value.length -1

    const data = {
        model:"logctmo",
        data:{
            compania: '300',
            agencia: '001',
            fecha: formDataI.value.fecha,
            almacen: '02',
            codigo: formDataI.value.codigo,
            documento: formDataI.value.documento,
            creado_por:userStore.globalUser,
            fecha_creado: dateTimeStore.formattedDate,
            hora_creado: dateTimeStore.formattedTime,
            guia_despacho: formDataI.value.guia,
            cliente: formDataI.value.cliente,
            fecha_llegada: formDataI.value.fecha_llegada,
            hora_llegada: formDataI.value.hora_llegada,
            comentario: formDataI.value.comentario,
            status: formDataI.value.status,
                  
        }
    }
    
    try { 
        const response = await fetch(dUrl.urlGlobal +'/api2/insert/',{
            method: 'POST',
            headers:{
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
        if(response.ok){
            const responseData = await response.json()

            console.log("Insercion exitosa:",responseData)
        
            try {
                const response = await axios.post(dUrl.urlGlobal + '/api2/query', { tabla: 'carussec', 
                    filtro: { usuario: userStore.globalUser, tabla: 'logctmo' }});

                dataList.value = response.data;
                docto = dataList.value[0].secuencia

            } catch(err: any) {
                error('NO se pudo accesar el secuencial de almacen')
            }
            
// INSERT DEL ARRAY
            
            for (const fila of registros.value) {
            const data = {
            model: "logdemo",
            data: {
                compania: '300',
                agencia: '001',
                fecha: formDataI.value.fecha,
                almacen: '02',
                codigo: formDataI.value.codigo,
                documento: docto,
                secuencia: fila.secuencia,
                orden_produccion: fila.orden_produccion,
                pallets: fila.pallets,
                peso: fila.peso,
                cajas: fila.cajas,
                unidad: 0,
                creado_por: userStore.globalUser,
                fecha_creado: dateTimeStore.formattedDate,
                hora_creado: dateTimeStore.formattedTime,
                status: formDataI.value.status
                }
            }
            try {
                const response = await fetch(dUrl.urlGlobal + '/api2/insert/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            })
            if (!response.ok) {
            // Puedes registrar el error y seguir con el siguiente
                error(`Error al insertar registro con pallet: ${fila.orden_produccion}`)
                }else{
                //vali++
            }
            } catch (err: any) {
                error(`Error inesperado en el número ${fila.orden_produccion}:`, err)
      }
    }   
// Fin de Insert
            handleClick()
        }else{
            console.error("Error al insertar en la base de datos:",response.statusText)
        }
    }catch (error){
        console.error("error de red:",error)
    }
}
 
// final handle submit
const registros = ref<Registro[]>([
  { secuencia: fila, orden_produccion: '', pallets: '', cajas: '', peso: '', status: 'A' }
])

// Estado del formulario y la data
const formDataI = ref({
  fecha: fecha.value,
  status: 'I',
  guia: '',
  fecha_llegada: dateTimeStore.formattedDate,
  hora_llegada: dateTimeStore.formattedTime, 
  codigo: '',
  documento: '',
  cliente: '',
  comentario: ''

});

// Variables de control
const dataList = ref<any[]>([]); // Lista de datos de la API
//----------------------------------------------------------------------------------------------
const codigos = ref<any[]>([]);
const clientes = ref<any[]>([])
onMounted( async () => {
  const responseN = await axios.get(dUrl.urlGlobal + '/api2/logtral/filter?status=A')
  codigos.value = responseN.data

  const responseC = await axios.get(dUrl.urlGlobal + '/api2/crmclte/filter?status=A')
  clientes.value = responseC.data
})
//computados de las ayudas
const descripcionCodigo = computed(() => {
  const encontrado = codigos.value.find(op => op.codigo === formDataI.value.codigo)
  return encontrado ? encontrado.descripcion : ''
})

const descripcionCliente = computed(() => {
  const encontrado = clientes.value.find(op => op.cliente === formDataI.value.cliente)
  return encontrado ? encontrado.nombre_comercial : ''
})

//control de filas automaticas de la tabla-----------------------------------------------------------------------------------------------------------------

// Función para validar si una fila está completamente llena
const filaLlena = (fila: Registro | undefined | null) => {
  if (!fila) return false;

  return Object.values(fila).every(val => {
    if (typeof val === 'string') {
      return val.trim() !== ''
    }
    if (typeof val === 'number') {
      return !isNaN(val)
    }
    return false
  })
}
// Observar el último elemento y agregar uno nuevo si está lleno
watch(registros, (newVal) => {
  // Evitar errores si el array está vacío
  if (!newVal.length) {
    fila + 1
    registros.value.push({
      secuencia: fila,
      orden_produccion: '',
      pallets: '',
      cajas: '',
      peso: '',
      status: 'A'
    });
    return;
  }

  // Evaluar la última fila
  const ultimaFila = newVal[newVal.length - 1];
  if (filaLlena(ultimaFila)) {
    fila++
    registros.value.push({
      secuencia: fila,
      orden_produccion: '',
      pallets: '',
      cajas: '',
      peso:'',
      status: 'A'
    });
  }
}, { deep: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", null, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formDataI.value.fecha) = $event)),
                  class: "form-control",
                  id: "validationCustom01",
                  required: "",
                  disabled: ""
                }, null, 512), [
                  [_vModelText, formDataI.value.fecha]
                ])
              ]),
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formDataI.value.fecha_llegada) = $event)),
                  id: "validationCustom01",
                  required: ""
                }, null, 512), [
                  [_vModelText, formDataI.value.fecha_llegada]
                ])
              ]),
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  type: "time",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formDataI.value.hora_llegada) = $event)),
                  id: "validationCustom02",
                  required: ""
                }, null, 512), [
                  [_vModelText, formDataI.value.hora_llegada]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formDataI.value.codigo) = $event))
                }, [
                  _createElementVNode("option", _hoisted_17, _toDisplayString(descripcionCodigo.value), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codigos.value, (op) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: op.codigo,
                      value: op.codigo
                    }, _toDisplayString(op.descripcion), 9, _hoisted_18))
                  }), 128))
                ], 512), [
                  [_vModelSelect, formDataI.value.codigo]
                ])
              ]),
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formDataI.value.documento) = $event)),
                  class: "form-control",
                  id: "validationCustom01",
                  required: "",
                  disabled: ""
                }, null, 512), [
                  [_vModelText, formDataI.value.documento]
                ])
              ]),
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control form-control-sm",
                  type: "text",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formDataI.value.guia) = $event))
                }, null, 512), [
                  [_vModelText, formDataI.value.guia]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formDataI.value.cliente) = $event))
                }, [
                  _createElementVNode("option", _hoisted_26, _toDisplayString(descripcionCliente.value), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clientes.value, (op) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: op.cliente,
                      value: op.cliente
                    }, _toDisplayString(op.nombre_comercial), 9, _hoisted_27))
                  }), 128))
                ], 512), [
                  [_vModelSelect, formDataI.value.cliente]
                ])
              ]),
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formDataI.value.status) = $event)),
                  id: "validationCustom04",
                  required: "",
                  disabled: ""
                }, _hoisted_32, 512), [
                  [_vModelSelect, formDataI.value.status]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formDataI.value.comentario) = $event)),
                  class: "form-control",
                  id: "validationCustom01",
                  required: ""
                }, null, 512), [
                  [_vModelText, formDataI.value.comentario]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("form", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(registros.value, (registro, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row g-3 mb-2",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_38, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((registro.secuencia) = $event),
                      type: "text",
                      class: "form-control form-control-sm",
                      id: "validationDefault03",
                      placeholder: "Sec.",
                      disabled: ""
                    }, null, 8, _hoisted_39), [
                      [_vModelText, registro.secuencia]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((registro.orden_produccion) = $event),
                      type: "text",
                      class: "form-control form-control-sm",
                      id: "validationDefault03",
                      placeholder: "No. Pallet"
                    }, null, 8, _hoisted_41), [
                      [_vModelText, registro.orden_produccion]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((registro.pallets) = $event),
                      type: "text",
                      class: "form-control form-control-sm",
                      id: "validationDefault02",
                      placeholder: "Pallets"
                    }, null, 8, _hoisted_43), [
                      [_vModelText, registro.pallets]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((registro.cajas) = $event),
                      type: "text",
                      class: "form-control form-control-sm",
                      id: "validationDefault02",
                      placeholder: "Cajas"
                    }, null, 8, _hoisted_45), [
                      [_vModelText, registro.cajas]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((registro.peso) = $event),
                      type: "text",
                      class: "form-control form-control-sm",
                      id: "validationDefault02",
                      placeholder: "Peso"
                    }, null, 8, _hoisted_47), [
                      [_vModelText, registro.peso]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select",
                      "onUpdate:modelValue": ($event: any) => ((registro.status) = $event),
                      id: "validationCustom04",
                      required: "",
                      disabled: ""
                    }, _hoisted_52, 8, _hoisted_49), [
                      [_vModelSelect, registro.status]
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", { class: "col-12" }, [
          _createElementVNode("button", {
            class: "btn btn-secondary me-2",
            type: "button",
            style: {"background-color":"#24292F"},
            onClick: handleClick
          }, "Cancelar"),
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            style: {"background-color":"#001982"},
            onClick: handleSubmit
          }, "Enviar")
        ])
      ])
    ])
  ], 64))
}
}

})